import { gql } from '@apollo/client';

export const GET_USER_BY_ID = gql`
  query GetUserById($userId: ID!) {
    userById(id: $userId) {
      id
      name
      nickname
      profile_photo_urls {
        original
        thumbnail
        small
        medium
        large
      }
      followers_count
      following_count
      applauses_count
      is_followed
      is_follower
      is_me
    }
  }
`;

export const TOGGLE_FOLLOW = gql`
  mutation ToggleFollow($userId: ID!) {
    toggleFollow(user_id: $userId) {
      success
      message
      is_following
      user {
        id
        name
        nickname
        followers_count
        following_count
        applauses_count
        is_followed
        is_follower
        is_me
      }
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      success
      message
      user {
        id
        name
        nickname
        bio
        profile_photo_urls {
          original
          thumbnail
          small
          medium
          large
        }
      }
    }
  }
`;

export const GET_USER_FOLLOWERS = gql`
  query GetUserFollowers($userId: ID!, $first: Int, $page: Int) {
    userFollowers(user_id: $userId, first: $first, page: $page) {
      id
      name
      nickname
      is_followed
      is_me
      profile_photo_urls {
        medium
        thumbnail
        small
      }
    }
  }
`;

export const GET_USER_FOLLOWING = gql`
  query GetUserFollowing($userId: ID!, $first: Int, $page: Int) {
    userFollowing(user_id: $userId, first: $first, page: $page) {
      id
      name
      nickname
      is_followed
      is_me
      profile_photo_urls {
        medium
        thumbnail
        small
      }
    }
  }
`; 